import type { StatusVariantMap } from '@zafroi/ui-kit';

export const subscriptionStatusVariants: StatusVariantMap = {
  DRAFT: { label: 'Draft', tone: 'neutral' },
  ACTIVE: { label: 'Active', tone: 'success' },
  PAUSED: { label: 'Paused', tone: 'warning' },
  ENDED: { label: 'Ended', tone: 'neutral' },
};
